var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvironmentMatt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_187)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "#024969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: 692,
    width: 1492,
    height: 346,
    fill: "#142933"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.284,
    y: 166.908,
    width: 126.6,
    height: 199.184,
    fill: "#012231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M572.884 161H437V372H572.884V161ZM562.756 171.972H447.128V359.34H562.756V171.972Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.04,
    y: 247.088,
    width: 11.816,
    height: 135.04,
    transform: "rotate(90 572.04 247.088)",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.195 191.548C473.144 189.712 475.387 188.784 476.648 190.118L480.68 194.383C481.249 194.986 482.132 195.175 482.898 194.857L488.438 192.564C490.299 191.793 492.003 193.947 490.825 195.581L487.893 199.65C487.332 200.429 487.403 201.496 488.062 202.193L491.441 205.768C492.755 207.158 491.554 209.423 489.666 209.116L483.194 208.063C482.446 207.941 481.694 208.253 481.251 208.868L477.417 214.187C476.298 215.739 473.848 214.986 473.795 213.074L473.658 208.157C473.631 207.198 472.927 206.393 471.98 206.239L467.029 205.434C465.041 205.11 464.724 202.383 466.585 201.612L472.125 199.318C472.891 199.001 473.382 198.244 473.359 197.415L473.195 191.548Z",
    fill: "#FFC164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.591 233.181C482.54 231.346 484.782 230.417 486.043 231.752L486.572 232.311C487.142 232.914 488.025 233.103 488.791 232.785L489.328 232.563C491.065 231.844 492.655 233.853 491.556 235.378V235.378C491.033 236.104 491.109 237.111 491.724 237.762V237.762C493.007 239.119 491.874 241.37 490.031 241.07L488.945 240.894C488.197 240.772 487.444 241.084 487.001 241.699L486.358 242.591C485.266 244.106 482.873 243.315 482.821 241.448V241.448C482.796 240.553 482.139 239.787 481.255 239.643V239.643C479.4 239.341 479.104 236.796 480.841 236.077L481.378 235.855C482.144 235.537 482.635 234.78 482.612 233.951L482.591 233.181Z",
    fill: "#FFC164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.131 206.173C512.08 204.338 514.322 203.409 515.583 204.744L516.112 205.303C516.682 205.906 517.565 206.094 518.331 205.777L518.868 205.555C520.605 204.836 522.195 206.845 521.096 208.37V208.37C520.573 209.096 520.649 210.103 521.264 210.753V210.753C522.547 212.11 521.414 214.362 519.571 214.062L518.485 213.885C517.737 213.764 516.984 214.075 516.541 214.69L515.898 215.583C514.806 217.098 512.413 216.306 512.361 214.44V214.44C512.336 213.545 511.679 212.779 510.795 212.635V212.635C508.94 212.333 508.644 209.788 510.381 209.069L510.918 208.846C511.684 208.529 512.175 207.772 512.152 206.943L512.131 206.173Z",
    fill: "#FFC164"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentMatt);
export default __webpack_public_path__ + "static/media/environment_matt.99ff303a4b17489a260ae15060bc8b92.svg";
export { ForwardRef as ReactComponent };